/** CRA public-folder asset URL (files in src/frontend/public/). */
export function publicUrl(path: string): string {
  const base = process.env.PUBLIC_URL ?? "";
  const file = path.replace(/^\//, "");
  return base ? `${base}/${file}` : `/${file}`;
}